<mat-card class="calculator" *ngIf="calcForm" [formGroup]="calcForm">
   <mat-card-header class="common-h3em">
      <mat-card-title id="calculatorItem" *ngIf="!last || calcForm.get('__patch').disabled">Item {{index + 1}}</mat-card-title>
      <button id="calculatorDeleteButton" mat-button *ngIf="!last && !calcForm.get('__patch').disabled" (click)="remove.emit()">
         <mat-icon id="calculatorDeleteIcon">delete</mat-icon>
      </button>
   </mat-card-header>

   <br/>

   <section>
      <mat-form-field>
         <mat-label>Pieces</mat-label>
         <input id="piecesInput" matInput type="number" min="1" formControlName="pieces"/>
         <mat-error libInputErrors [control]="calcForm.get('pieces')"></mat-error>
      </mat-form-field>

      <button id="piecesButton" mat-icon-button (click)="helper = !helper" tabindex="-1" matTooltip="Calculate Per Item">
         <mat-icon id="piecesIcon" [color]="helper ? 'accent' : 'primary'">calculate</mat-icon>
      </button>
   </section>

   <ng-container [formGroup]="weightGroup">
      <section *ngIf="helper">
         <mat-form-field>
            <mat-label>Quantity</mat-label>
            <input id="quantityInput" matInput type="number" min="0" formControlName="quantity"/>
            <mat-error id="quantityError" libInputErrors [control]="weightGroup.get('quantity')"></mat-error>
         </mat-form-field>

         <mat-form-field>
            <mat-label>Weight</mat-label>
            <input id="weightInput" matInput class="calc-input" type="number" min="0" formControlName="weight" />
            <mat-select id="weightSelect" class="calc-select" formControlName="weight_type">
               <mat-option id="weightOptionLbs" value="lbs">lbs</mat-option>
               <mat-option id="weightOptionKgs" value="kgs">kgs</mat-option>
            </mat-select>
            <mat-error id="weightError" libInputErrors [control]="weightGroup.get('weight')"></mat-error>
         </mat-form-field>
      </section>

      <section>
         <mat-form-field [floatLabel]="helper ? 'always' : null" [class.inactive]="weight_type.value === 'kgs' || calcForm.get('__patch').disabled">
            <mat-label id="weightLbsLabel" *ngIf="weight_type.value === 'lbs'">{{ helper ? 'Total ' : '' }}Weight</mat-label>
            <input id="weightLbsInput" matInput type="number" formControlName="weight_lbs" (focus)="weightGroup.get( 'weight_type' ).setValue( 'lbs' )" />
            <span id="weightLbs" matSuffix>lbs</span>
            <mat-error id="weightLbsError" libInputErrors [control]="weightGroup.get( 'weight_lbs' )"></mat-error>
         </mat-form-field>

         <mat-form-field [floatLabel]="helper ? 'always' : null" [class.inactive]="weight_type.value === 'lbs' || calcForm.get('__patch').disabled">
            <mat-label id="weightKgsLabel" *ngIf="weight_type.value === 'kgs'">{{ helper ? 'Total ' : '' }}Weight</mat-label>
            <input id="weightKgsInput" matInput type="number" tabIndex="-1" formControlName="weight_kgs" (focus)="weightGroup.get( 'weight_type' ).setValue( 'kgs' )" />
            <span id="weightKgs" matSuffix>kgs</span>
            <mat-error id="weightKgsError" libInputErrors [control]="weightGroup.get( 'weight_kgs' )"></mat-error>
         </mat-form-field>
      </section>
   </ng-container>

   <section>
      <mat-form-field>
         <mat-select id="dimensionsSelect" value="in" formControlName="measure_type" tabIndex="-1">
            <mat-option id="dimensionsOption" *ngFor="let type of measureTypes" [value]="type">Dimensions ({{type}})</mat-option>
         </mat-select>
         <mat-error id="dimensionsError" libInputErrors [control]="calcForm.get('measure_type')"></mat-error>
      </mat-form-field>
   </section>

   <section>
      <mat-form-field>
         <mat-label>Length</mat-label>
         <input id="lengthInput" matInput type="number" min="0" formControlName="length" />
         <mat-error id="lengthError" libInputErrors [control]="calcForm.get('length')"></mat-error>
      </mat-form-field>
      <mat-form-field>
         <mat-label>Width</mat-label>
         <input id="widthInput" matInput type="number" min="0" formControlName="width" />
         <mat-error id="widthError" libInputErrors [control]="calcForm.get('width')"></mat-error>
      </mat-form-field>
      <mat-form-field>
         <mat-label>Height</mat-label>
         <input id="heightInput" matInput type="number" min="0" formControlName="height" />
         <mat-error id="heightError" libInputErrors [control]="calcForm.get('height')"></mat-error>
      </mat-form-field>
   </section>

   <section>
      <mat-form-field>
         <mat-label>Item Description</mat-label>
         <input id="itemDescriptionInput" matInput formControlName="description" />
         <mat-error id="itemDescriptionError" libInputErrors [control]="calcForm.get('description')"></mat-error>
      </mat-form-field>
   </section>

   <section>
      <mat-form-field>
         <mat-label>Item Reference</mat-label>
         <input id="itemReferenceInput" matInput formControlName="reference" />
         <mat-error id="itemReferenceError" libInputErrors [control]="calcForm.get('reference')"></mat-error>
      </mat-form-field>
   </section>
</mat-card>
